import React from "react";
import "./SelectItemsTable.css";
import GridIcon from "../../../assets/icons/grid.svg";
import ReportIcon from "../../../assets/icons/report-dash-icon.svg";

const statusConfig = {
  Published: { label: "Published", className: "status-published" },
  Draft: { label: "Draft", className: "status-draft" },
  Archived: { label: "Archived", className: "status-archived" },
};

const SelectItemsTable = ({ items = [] }) => {
  const defaultItems = [
    {
      id: 1,
      name: "Q2 Performance Dashboard",
      subtype: "Dashboard",
      type: "Dashboard",
      owner: "Justin Fagundez",
      status: "Published",
      timestamp: "May 6, 2025 11:42 AM",
    },
    {
      id: 2,
      name: "Customer Churn Report",
      subtype: "Report",
      type: "Report",
      owner: "Sarah Chen",
      status: "Draft",
      timestamp: "May 5, 2025 4:20 PM",
    },
    {
      id: 3,
      name: "Weekly Sales Summary",
      subtype: "Report",
      type: "Report",
      owner: "Marcus Rivera",
      status: "Published",
      timestamp: "May 5, 2025 9:15 AM",
    },
    {
      id: 4,
      name: "Product Usage Metrics",
      subtype: "Dashboard",
      type: "Dashboard",
      owner: "Justin Fagundez",
      status: "Archived",
      timestamp: "May 4, 2025 2:38 PM",
    },
    {
      id: 5,
      name: "Marketing Funnel Q1",
      subtype: "Dashboard",
      type: "Dashboard",
      owner: "Emily Park",
      status: "Published",
      timestamp: "May 3, 2025 10:00 AM",
    },
  ];

  const displayItems = items.length > 0 ? items : defaultItems;

  return (
    <div className="dashboard-items-table-container">
      <div className="table-header">
        <h3 className="table-title">Recent Dashboards & Reports</h3>
        <button className="view-all-btn">View All</button>
      </div>

      <div className="table-wrapper">
        <table className="dashboard-items-table">
          <thead>
            <tr>
              <th>Name</th>
              <th>Type</th>
              <th>Owner</th>
              <th>Status</th>
              <th>Updated</th>
            </tr>
          </thead>
          <tbody>
            {displayItems.map((item) => (
              <tr key={item.id}>
                <td>
                  <div className="name-cell">
                    <div className="name-icon">
                      <img src={item.type === "Dashboard" ? GridIcon : ReportIcon} alt={item.type} />
                    </div>
                    <div>
                      <div className="name-primary">{item.name}</div>
                      <div className="name-secondary">{item.subtype}</div>
                    </div>
                  </div>
                </td>
                <td>
                  <span className={`type-badge type-${item.type?.toLowerCase()}`}>{item.type}</span>
                </td>
                <td className="owner-cell">{item.owner}</td>
                <td>
                  <span className={`status-badge ${statusConfig[item.status]?.className}`}>{item.status}</span>
                </td>
                <td className="timestamp-cell">{item.timestamp}</td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
};

export default SelectItemsTable;
